<template lang="pug">
.d-flex.align-center
  v-btn(
    icon
    small
    :disabled="value <= min"
    @click="inputValue -= step"
  )
    v-icon mdi-minus
  v-text-field.counter(
    v-model="inputValue"
    v-bind="$attrs"
    rounded
    filled
    hide-details
    auto-grow
    :size="`${this.inputValue}`.length"
    @keyup.arrow-up="inputValue += step"
    @keyup.arrow-down="inputValue -= step"
  )
  v-btn(
    icon
    small
    :disabled="value >= max"
    @click="inputValue += step"
  )
    v-icon mdi-plus
</template>

<script>
export default {
  props: {
    value: { type: Number, default: 0 },
    max: { type: Number, default: 9999 },
    min: { type: Number, default: 1 },
    step: { type: Number, default: 1 },
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        return this.$emit('input', Number(val));
      },
    },
  },
  watch: {
    inputValue(val) {
      this.inputHandle(String(val));
    },
  },
  methods: {
    inputHandle(val) {
      let count = Number(val.slice(-`${this.max}`.length));
      if (Number.isNaN(count)) {
        count = this.min;
      }

      count = Math.round(count / this.step) * this.step;

      if (count <= this.min) {
        this.updateValue(this.min);
      } else if (count >= this.max) {
        this.updateValue(this.max);
      } else {
        this.updateValue(count);
      }
    },
    updateValue(val) {
      this.$nextTick(() => {
        this.$emit('input', val);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.counter {
  ::v-deep input {
    text-align: center;
  }
}
</style>
